import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function ViolationsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/violations"); setItems(data.items); })(); }, []);
  return (
    <div>
      <PageHeader eyebrow="Compliance" title="Your Violations" subtitle="If anything looks incorrect, contact the property manager." />
      <div className="space-y-3">
        {items.map((v) => (
          <Card key={v.id} className="p-5 bg-white">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-semibold">{v.type}</div>
                <div className="text-sm text-zinc-600 mt-1">{v.description}</div>
                <div className="text-xs text-zinc-500 mt-2">Issued {new Date(v.created_at).toLocaleDateString()}</div>
              </div>
              <div className="text-right">
                <Badge variant="outline" className="capitalize">{v.severity}</Badge>
                {v.fine > 0 && <div className="mt-2 tabular-nums font-semibold text-rose-600">${Number(v.fine).toLocaleString()}</div>}
              </div>
            </div>
          </Card>
        ))}
        {items.length === 0 && <div className="text-sm text-muted-foreground">You have no violations. Nicely done.</div>}
      </div>
    </div>
  );
}
